export default __webpack_public_path__ + "static/footer-orange-bg-7a89a4f72cec9fb8df75d06143fa61c2.png";